import React from 'react'
import useInput from './useInput'
import resolveProps, { resolveFns } from '../../utils/resolveProps'
import InputMask from 'react-input-mask'

const InternalInput = (props, ref) => {
  let {
    parentProps = '',
    parentClassName = '',
    className = '',
    options,
    disabled = false,
    email = false,
    cep = false,
    cpf = false,
    textarea = false,
    cnpj = false,
    phone = false,
    cpfCnpj = false,
    phoneMobile = false,
    phoneFixed = false,
    text = false,
    date = false,
    number = false,
    password = false,
    search = false,
    action = false,
    select = false,
    required = false,
    id,
    onChange,
    onBlur,
    isDisabled,
    children,
    actionProps = {},
    buttonProps = {},
    errorMessage = 'Por favor, preencha este campo corretamente.',
    hasError = false,
    ...rest
  } = props

  const {
    config,
    currentValue,
    hidden,
    error,
    inputType,
    handleChange,
    handleBlur,
    setHidden,
    setCurrentValue,
    beforeMaskedStateChange,
    mask,
    loading
  } = useInput(props)

  const inputId =
    id ||
    `input__${new Date()
      .valueOf()
      .toString()
      .match(/\d{6}$/)[0]
    }`

  const {
    buttonClasses = '',
    buttonLabel = '',
    buttonClick = () => { },
    ...buttonRest
  } = buttonProps

  const renderInputField = () => {
    const fields = {
      textarea: (
        <>
          <textarea
            {...rest}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={inputType.title}
            onChange={resolveFns(handleChange, onChange)}
            ref={ref}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={id} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),

      password: (
        <>
          <input
            {...rest}
            id={inputId}
            className={'mdn-Input-field ' + (className || '')}
            type={hidden ? 'password' : 'text'}
            data-mdn-type="password"
            ref={ref}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            required={required}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <button
            className="mdn-Input-action"
            data-mdn-action="reveal-password"
            onClick={resolveFns(() => setHidden(!hidden), buttonClick)}
            type="button"
            role="button"
          >
            <span
              aria-label={`${hidden ? 'Ocultar senha' : 'Exibir senha'} `}
              className={`${hidden ? 'mdn-Icon-exibir' : 'mdn-Icon-ocultar'
                } mdn-Icon--md`}
            />
          </button>
        </>
      ),

      action: (
        <>
          <input
            {...rest}
            className={`mdn-Input-field ${className} `}
            data-mdn-type={inputType.title}
            type="text"
            id={inputId}
            ref={ref}
            required={required}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <button
            className={`mdn-Input-action ${buttonClasses}`}
            onClick={resolveFns(buttonClick)}
            type="button"
            aria-label="Enviar"
            {...buttonRest}
          >
            <span className="mdn-Icon-direita mdn-Icon--md"></span>
          </button>
        </>
      ),
      date: (
        <>
          <input
            {...rest}
            mask={mask}
            maskPlaceholder={'_'}
            ref={ref}
            id={inputId}
            data-mdn-type={inputType?.title}
            className="mdn-Input-field" //{ + (props?.className || '')}
            type={inputType?.title}
            data-mdn-type={inputType.title}
            value={currentValue}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      default: (
        <>
          <InputMask
            {...rest}
            mask={mask}
            maskPlaceholder={'_'}
            ref={ref}
            id={inputId}
            data-mdn-type={inputType?.title}
            className="mdn-Input-field" //{ + (props?.className || '')}
            type={inputType?.type}
            data-mdn-type={inputType.title}
            value={currentValue}
            required={required}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
            beforeMaskedStateChange={beforeMaskedStateChange}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      search: (
        <>
          <input
            {...rest}
            id={inputId}
            className="mdn-Input-field"
            type="text"
            ref={ref}
            id={inputId}
            data-mdn-type="search"
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            value={currentValue}
          />

          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <button
            onClick={resolveFns(() => setCurrentValue(''), buttonClick)}
            className="mdn-Input-action"
            type="button"
            role="button"
          >
            <span
              className={`${!currentValue ? 'mdn-Icon-busca' : 'mdn-Icon-fechar'
                } mdn-Icon--md`}
              aria-label="Search"
            ></span>
          </button>
        </>
      ),
      select: (
        <>
          <select
            {...rest}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={inputType.title}
            id={inputId}
            onChange={resolveFns(handleChange, onChange)}
            value={currentValue}
            ref={ref}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
          >
            {options?.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      )
    }

    return fields[inputType.title] || fields.default
  }

  return (
    <div
      {...parentProps}
      className={`${resolveProps(props, config, 'Input')} ${parentClassName}
          ${currentValue ? 'mdn-Input--activatedField' : ''}
          ${error.hasError ? 'mdn-Input--attentionField' : ''}`
        .replace(/\s{2,}/g, ' ')
        .trim()}
    >
      {renderInputField()}
      {<small className="mdn-Input-errorFeedback">{error.message}</small>}
    </div>
  )
}

export const Input = React.forwardRef(InternalInput)
